import styled from '@emotion/styled'
import { Box } from '@mui/material'

export const ToolTipWrap = styled(Box)(props => `
    position:relative;

    &:before {
        content:attr(data-title);
        position:absolute;
        ${props.valign === 'top' ? 'top: -25px' : ''};
        ${props.valign === 'bottom' ? 'bottom: -25px' : ''};
        
        ${props.align === 'center' ? 'left:50%; transform: translateX(-50%) scale(0);' : ''}
        ${props.align === 'right' ? 'right: 0; transform: scale(0);' : ''};

        transform-origin: ${props.valign} ${props.align};
        z-index:1;
        background:#EFEFEF;
        padding: 2px 8px;
        line-height: 16px;
        font-size: 12px;
        opacity:0;
        border-radius:4px;
        visibility: hidden;
        white-space: nowrap;
        transition: transform 0.2s ease-out, opacity 0.2s ease-out, visibility 0.3s ease;

        color: #000 !important;
        font-weight: 400 !important;
    }
    &:hover:before {
        visibility: visible;
        opacity:1;
        ${props.align === 'center' ? 'transform: translateX(-50%) scale(1)' : ''};
        ${props.align === 'right' ? 'transform: scale(1)' : ''};

        color: #000 !important;
        font-weight: 400 !important;
    }
`)
